// / — index route.
// -----------------------------------------------------------------
// Redirects to /hello unconditionally; the _authenticated layout
// route gates auth from there. M3.2 has only the /hello route under
// _authenticated; M4+ replaces this default destination as real
// pages land (per plan § 7.3 — landing route LOCKED 2026-05-03 to
// route to whatever the M3.2 sample is, then change as M4+ lands).

import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/')({
  beforeLoad: () => {
    throw redirect({ to: '/dashboards' });
  },
});
